import { TexturesNames } from '../types'

/**
 * Specialny konfig pre sponzorov v hre
 */
export const sponsorsConfig = {

  // bannery
  banners: [

    {
      name: 'vshosting',
      textureName: TexturesNames.colorGradientVshosting,
      active: true,
      times: [

        {
          from: 1724882400000, // 29.8.2024
          to: 1726092000000, // 12.9.2024
          percent: 0.1 // 10%
        },
        {
          from: 1726092000000, // 12.9.2024
          to: 1727301600000, // 26.9.2024
          percent: 0.3 // 30%
        }

      ]
    }

  ]

}
